<template>
  <div>
    <div class="text-center" v-if="!dataLoaded">
      <v-progress-circular class="mt-6" :size="50" color="primary" indeterminate />
    </div>

    <div class="mt-1" v-show="dataLoaded">
      <v-row>
        <v-col cols="12" class="d-flex align-end justify-space-between">
          <v-btn
            small
            outlined
            color="primary"
            class="white--text px-4"
            @click="dialog = true"
          >
            <v-icon left small>mdi-plus</v-icon>Добавить
          </v-btn>
        </v-col>
      </v-row>

      <PageTable
        :table-loading="tableLoading"
        :table-headers="tableHeaders"
        :table-items="submissionSession.list"
      >
        <template v-slot:item.current="{ item }">
          <span>{{ item.current ? 'Да' : 'Нет'}}</span>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon color="lightGrey" class="mr-2 eye-btn" size="22" title="Просмотр" @click="show(item)">
            mdi-eye-outline
          </v-icon>
          <v-icon color="lightGrey" class="mr-1 edit-btn" size="22" title="Редактировать" @click="edit(item)">
            mdi-pencil-outline
          </v-icon>
          <v-icon color="lightGrey" class="remove-btn" size="22" title="Удалить" @click="remove(item)">
            mdi-trash-can-outline
          </v-icon>
        </template>
      </PageTable>
    </div>

    <SubmissionSessionDialog
      :dialog="dialog"
      :saveBtnLoading="btnLoading"
      :selectedItem="selectedItem"
      :isShowMode="isShowMode"
      @saveSubmissionSession="saveSubmissionSession"
      @closeModal="closeDialog"
    />

    <ConfirmDialog
      :dialog="confirmDialog"
      :loading="btnLoading"
      :message="`Вы уверены, что хотите удалить значение из справочника?`"
      @confirm="removeSubmissionSession"
      @closeModal="closeDialog"
    />
  </div>
</template>

<script>
import { submissionSessionApi } from '@/api'
import { SubmissionSessions } from '@/models'
import PageTable from '@/components/ui/Table'
import SubmissionSessionDialog from '@/components/zvp/dictionaries/submissionSession/dialogs/SubmissionSession'
import ConfirmDialog from '@/components/dialogs/ConfirmDelete'

export default {
  name: 'SubmissionSessions',

  components: {
    PageTable,
    SubmissionSessionDialog,
    ConfirmDialog
  },

  async created() {
    await this.$store.dispatch('user/getCurrent')
    await this.getGroups()
    this.dataLoaded = true
  },

  data: () => ({
    tableHeaders: [
      { text: 'Id', value: 'id', sortable: false, align: 'start' },
      { text: 'Учебный год', value: 'academyYear.name', sortable: false, align: 'start' },
      { text: 'Семестр', value: 'semesterType.name', sortable: false, align: 'start' },
      { text: 'Текущий период подачи', value: 'current', sortable: false, align: 'start' },
      { text: 'Код', value: 'submissionCode', sortable: false, align: 'start' },
      { text: 'Имя', value: 'submissionName', sortable: false, align: 'start' },
      { text: 'Действия', value: 'actions', sortable: false, align: 'center', width: '130px' }
    ],
    submissionSession: new SubmissionSessions(),
    dataLoaded: false,
    tableLoading: false,
    selectedItem: null,
    isShowMode: false,
    dialog: false,
    confirmDialog: false,
    btnLoading: false,
  }),

  methods: {
    async getGroups() {
      const data = await submissionSessionApi.getCatalog()
      if (data.length) data.forEach(obj => this.submissionSession.addSubmissionSession(obj))
    },

    async saveSubmissionSession(body) {
      try {
        if (body.current && this.submissionSession.list.find(item => item.current))
          this.$toastr('error', '', 'Текущий период подачи уже назначен')
        else {
          this.btnLoading = true

          const data = body.id ?
            await submissionSessionApi.updateSubmissionSession(body) :
            await submissionSessionApi.saveSubmissionSession(body)

          body.id ?
            this.submissionSession.updateSubmissionSession(data) :
            this.submissionSession.addSubmissionSession(data)

          this.$toastr('success', '', 'Успешно сохранено')
          this.closeDialog()
        }
      } catch (e) {
        this.$toastr('error', '', 'Ошибка сохранения')
      } finally {
        this.btnLoading = false
      }
    },

    async removeSubmissionSession() {
      try {
        this.btnLoading = true

        await submissionSessionApi.removeSubmissionSession(this.selectedItem.id)
        this.submissionSession.removeSubmissionSession(this.selectedItem.id)
        this.$toastr('success', '', 'Успешно удалено')
        this.closeDialog()
      } catch (e) {
        this.$toastr('error', '', 'Ошибка удаления')
      } finally {
        this.btnLoading = false
      }
    },

    show(item) {
      this.selectedItem = item
      this.dialog = true
      this.isShowMode = true
    },

    edit(item) {
      this.selectedItem = item
      this.dialog = true
    },

    remove(item) {
      this.selectedItem = item
      this.confirmDialog = true
    },

    closeDialog() {
      this.dialog = false
      this.confirmDialog = false
      this.selectedItem = null
      this.isShowMode = false
    },
  },
}
</script>

<style scoped>
</style>
